define('views/modules/calendar/nutrition/food/food-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // services
    'services/events/nutrition-events',
    //'services/user',
    // collections
    'collections/calendar/nutrition/food-favorites',
    // views
    'views/parts/panel/base-panel',
    'views/modules/calendar/nutrition/food/favorite/food-favorite-content',
    'views/modules/calendar/nutrition/food/search/food-search-content',
    'views/modules/calendar/nutrition/food/suggestion/food-suggestion-content',
], function(
    // Libs
    _, Backbone, U,
    //services
    NutritionEvents,
    //User,
    // collections
    CFoodFavorites,
    // views
    VBasePanel,
    VFoodFavoriteContent,
    VFoodSearchContent,
    VFoodSuggestionContent
) {

    var FAVORITE_TYPES = ['food', 'customFood', 'recipe'];

    var VFoodPanel = VBasePanel.extend({
        header: {
            title: "calendar:Search Foods",
            subtitle: "calendar:Find/Add food to your nutrition log",
        },
        content: {
            search: VFoodSearchContent,
            fridge: VFoodFavoriteContent,
            history: VFoodFavoriteContent,
            suggest: VFoodSuggestionContent,
        },

        defaults: function() {
            return {
                recipe: true,
                suggestion: true,
                favorite: new CFoodFavorites(null, {
                    types: FAVORITE_TYPES,
                    full: true
                })
            };
        },

        tabs: function() {
            var tabs = [
                { id: 'search', title: 'Search', icon: 'sl-icon-magnifier', active: true, callback: 'showSearch' },
                { id: 'fridge', title: 'calendar:Fridge', icon: 'sl-icon-star', callback: 'showFridge' },
                { id: 'history', title: 'Recent', icon: 'sl-icon-clock', callback: 'showHistory' },
            ];
            //if (this.options.suggestion) tabs.push({ id: 'suggest', title: 'calendar:Suggest', icon: 'sl-icon-bulb', callback: 'showSuggestion' });
            return tabs;
        },

        initialize: function(options) {
            this.collection = this.options.favorite;

            this.listenTo(NutritionEvents, 'refreshPanel', this.onRefreshPanel);
            this.listenTo(NutritionEvents, 'showFavorites', this.onShowFavorites);
        },

        render: function() {
            this.collection.fetch();
            VFoodPanel.__super__.render.apply(this, arguments);
            this.showSearch();
            return this;
        },

        showSearch: function() {
            this.showContent('search', this.options);
        },
        showFridge: function() {
            var key = 'fridge',
                options;
            if (!this.view[key]) {
                options = _.defaults({
                    types: FAVORITE_TYPES,
                }, this.options);
            }
            this.showContent('fridge', options);
        },
        showHistory: function() {
            var key = 'history',
                options;
            if (!this.view[key]) {
                options = _.defaults({
                    types: ['history'],
                }, this.options);
            }
            this.showContent(key, options);
        },
        showSuggestion: function() {
            this.showContent('suggest');
        },

        onRefreshPanel: function() {
            this.showSearch();
        },

        onShowFavorites: function() {
            this.showFridge();
        }

    });

    return VFoodPanel;
});

